<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Rating" pageTitle="Rating" />
            <RatingContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import RatingContent from '../Rating/RatingContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'RatingPage',
    components: {
        MainHeader,
        PageTitle,
        RatingContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>